<template>
  <FormModal title="Type de demande">
    <template #body>
      <ServiceFormStep :progress-value="progressValue" />
    </template>
  </FormModal>
</template>

<script>
import FormModal from 'chimera/all/themes/blueflow/components/layout/FormModal'
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import ServiceFormStep from '~/components/form/steps/service/ServiceFormStep'

export default {
  components: {
    ServiceFormStep,
    FormModal,
  },

  extends: AbstractFormPage,

  layout: 'form',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Type de demande',
      headDescription:
        'Précisez le type de fournisseur de châssis de fenêtre que vous recherchez.',
      path: '/quotes-requests/type-de-demande',
      progressValue: 33,
      checkoutStep: 2,
    }
  },
}
</script>
